import { useEffect, useMemo, useState } from 'react';
import { useProfessionals } from '../../../../hooks/useProfessionals';

/**
 * Provides the professionals combobox and pre-selects the treatment's professional.
 * The selection is optional: the component may clear it before saving.
 */
export function useTreatmentProfessional(treatment, isOpen) {
  const { professionals } = useProfessionals();
  const [selectedProfessional, setSelectedProfessional] = useState(null);

  const treatmentProfessional = useMemo(() => {
    if (!treatment || professionals.length === 0) return null;

    const treatmentProfessionalId = treatment.dentistId ?? treatment.dentistaId ?? null;
    if (treatmentProfessionalId != null) {
      return (
        professionals.find((professional) => {
          return String(professional.id) === String(treatmentProfessionalId);
        }) ?? null
      );
    }

    if (treatment.dentistName) {
      return (
        professionals.find((professional) => professional.nome === treatment.dentistName) ?? null
      );
    }

    return null;
  }, [treatment, professionals]);

  useEffect(() => {
    setSelectedProfessional(isOpen ? treatmentProfessional : null);
  }, [isOpen, treatmentProfessional]);

  return { professionals, selectedProfessional, setSelectedProfessional };
}
